import React from 'react';
import ReactPaginate from 'react-paginate';

export default function PaginatedItems({ items_per_page, total_items, on_pagination_click, cur_page })
{
    const pageCount = Math.ceil(total_items / items_per_page);
    const handlePageClick = (event) =>
    {
        const newOffset = (event.selected * items_per_page) % total_items;
        const start_offset = newOffset + 1;
        const end_offset = newOffset + items_per_page;
        if((event.selected + 1) !== cur_page)
        //if(true)
        {
            on_pagination_click({
                start: start_offset,
                stop: end_offset,
                page: (event.selected+1)
            });
        }
    };

    if(items_per_page > total_items) return <></>

    return (
        <>
            <div className='paginator_container'>
                <ReactPaginate
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    renderOnZeroPageCount={null}
                    previousLabel={<><i className='fa-solid fa-angle-left'></i> Previous</>}
                    nextLabel={<> Next <i className='fa-solid fa-angle-right'></i></>}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item page-item-prev"
                    previousLinkClassName="page-link"
                    nextClassName="page-item page-item-next"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={cur_page-1}
                />
            </div>
        </>
    );
}